import { connect } from 'react-redux';

import VideoPlaylistItem from './video_playlist_item.jsx';

import get from 'lodash/get';

import {
  getAssetForContent,
  getContentItemByUuid
} from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state, { uuid }) => {
  const contentItem = getContentItemByUuid(state, uuid);
  const asset = getAssetForContent(state, contentItem);

  // in the case that a content item and asset is not available yet, we return
  // an empty string for the <img /> tag until it rerenders with the proper
  // thumbnail URL.
  let thumbnail = '';
  let altText = '';

  if (contentItem && asset) {
    altText = contentItem.alt_text || get(asset, 'alt_text', '');

    if (contentItem.tile_display_type === 'default') {
      thumbnail = asset.thumbnail;
    } else {
      thumbnail = contentItem.tile_display_image;
    }
  }

  return { thumbnail, altText };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoPlaylistItem);
